import * as types from '../types.js'

export default {
    state: {
		delayFollowUpRecord:{}
    },
    mutations: {
        [types.DELAY_FOLLOW_UP_RECORD](state, data){
            state.delayFollowUpRecord = data
        },
    },
    actions: {
    	getDelayFollowUpRecord({commit},params){
            let that = params.vm
            serve.fetchGet(api.getDelayFollow,params.data).then(data => {
                commit(types.DELAY_FOLLOW_UP_RECORD,data);
                that.t_data = data.data
                that.pagination = data.meta.pagination
                that.loading = false
            }).catch((error)=>{
                that.loading = false
                that.$Message.error(error.response.data.message);
            })
	    }
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/delayFollowUpRecord.js